import {Component, inject} from '@angular/core';
import {UploadProgressService} from "../../../../core/services/upload-progress.service";

@Component({
  selector: 'app-file-progress-bar-status',
  standalone: true,
  imports: [],
  templateUrl: './file-progress-bar-status.component.html',
  styleUrl: './file-progress-bar-status.component.scss'
})
export class FileProgressBarStatusComponent {
  public uploadProgressService: UploadProgressService = inject(UploadProgressService);
}
